import * as React from 'react';

const GridViewFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M4 4h6v6H4zM14 4h6v6h-6zM14 14h6v6h-6zM4 14h6v6H4z" />
        </g>
    </svg>
);

GridViewFillSvg.displayName = 'GridViewFillSvg';
export default GridViewFillSvg;
